import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import FallbackLoader from "../../components/FallbackLoader";
import FreeTrialDialog from "../../components/dialog/FreeTrialDialog";

const MUITable = ({
  loading,
  data,
  columnLength,
  rowContent,
  isTableBlur,
  fixedHeaderContent,
  tableMessage = "No data available",
}) => {
  return (
    <TableContainer sx={{ maxHeight: 800 }} id="custom-mui-table">
      <Table
        stickyHeader
        aria-label="sticky table"
        sx={{
          borderCollapse: "separate",
          tableLayout: "fixed",
          cursor: "default",
        }}
      >
        <TableHead>{fixedHeaderContent()}</TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={columnLength} className="text-center">
                <FallbackLoader />
              </TableCell>
            </TableRow>
          ) : isTableBlur ? (
            <TableRow>
              <TableCell
                colSpan={columnLength}
                className="text-center p-0"
                sx={{ position: "relative" }}
              >
                <FreeTrialDialog />
              </TableCell>
            </TableRow>
          ) : data?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columnLength} className="text-center">
                {tableMessage}
              </TableCell>
            </TableRow>
          ) : (
            data?.map((item, index) => {
              return (
                <TableRow key={`mui-table-row-${index}`}>
                  {rowContent(index, item)}
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MUITable;
